import React, { useEffect, useRef, useState } from "react";
import "./header.css";
import { NavLink, Link } from "react-router-dom";

import Logo from "../../assets/logo.webp";
import MenuIcon from "../../assets/icons/menu.svg";
import closeIcon from "../../assets/icons/close.svg";
import ravisara__jayamanna from "../../assets/images/ravisara-jayamanna-1-1123x1536.webp";

const nav__links = [
  {
    path: "home",
    display: "HOME",
  },
  {
    path: "safaris",
    display: "SAFARIS",
  },
  {
    path: "portfolio",
    display: "PORTFOLIO",
  },
  {
    path: "prints",
    display: "PRINTS",
  },
  {
    path: "about",
    display: "ABOUT ME",
    submenu: [
      {
        path: "about",
        display: "ABOUT",
      },
      {
        path: "contact",
        display: "CONTACT",
      },
    ],
  },
  {
    path: "blog",
    display: "MEDIA",
    submenu: [
      {
        path: "blog",
        display: "BLOG",
      },
      {
        path: "publications",
        display: "PUBLICATIONS",
      },
      {
        path: "wildlife-photography-workshops-and-lectures",
        display: "OTHERS",
      },
    ],
  },
];

const Header = () => {
  //sticky header
  const headerRef = useRef(null);
  const stickyHeader = () => {
    window.addEventListener("scroll", () => {
      if (
        document.body.scrollTop > 80 ||
        document.documentElement.scrollTop > 80
      ) {
        headerRef.current.classList.add("sticky__header");
      } else {
        headerRef.current.classList.remove("sticky__header");
      }
    });
  };
  useEffect(() => {
    stickyHeader();

    return () => window.removeEventListener("scroll", stickyHeader);
  });

  const menuRef = useRef(null);
  const menuToggle = () => menuRef.current.classList.toggle("active__menu");
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const handleMouseEnter = (index) => {
    setHoveredIndex(index);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };

  const [showLeftMenu, setShowLeftMenu] = useState(false);

  const toggleLeftMenu = () => {
    setShowLeftMenu(!showLeftMenu);
  };

  const [toggleMobileMenu, setToggleMobileMenu] = useState(false);

  const handleMenuClick = () => {
    setToggleMobileMenu((prev) => !prev);
  };

  //get year
  const year = new Date().getFullYear();

  return (
    <header className="header" ref={headerRef}>
      <div className="w nav__wrapper fsb">
        <div className="logoMenu">
          <img
            className="menu__icon"
            src={MenuIcon}
            alt="Menu"
            onClick={toggleLeftMenu}
          />
          <Link className="logo" to="/">
            <img src={Logo} alt="logo" />
          </Link>
        </div>
        <div
          className="navigation"
          ref={menuRef}
          onClick={menuToggle}
          onMouseLeave={handleMouseLeave}
        >
          <ul className="menu">
            {nav__links.map((item, index) => (
              <li
                className="nav__item"
                key={index}
                onMouseEnter={() => handleMouseEnter(index)}
              >
                <NavLink
                  to={item.path}
                  className={(navClass) =>
                    navClass.isActive ? "nav__active" : ""
                  }
                >
                  {item.display}
                </NavLink>
                {hoveredIndex === index && item.submenu && (
                  <ul className="submenu">
                    {item.submenu.map((subItem, subIndex) => (
                      <li className="submenu__item" key={subIndex}>
                        <NavLink to={subItem.path}>{subItem.display}</NavLink>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>
        <div className={`left__menu ${showLeftMenu ? "open" : ""}`}>
          <img
            className="close__menu"
            src={closeIcon}
            alt="close menu"
            onClick={toggleLeftMenu}
          />
          <p className="left__menu-p">
            My name is Ravisara Jayamanna, and I specialize in capturing the
            essence of Sri Lanka’s wildlife through photography. My passion lies
            in documenting the beauty and fragility of our island’s unique
            ecosystem.
          </p>
          <img src={ravisara__jayamanna} alt="" />
          <h2>Contact</h2>
          <div className="left__menu-contact">
            <div className="left__menu-contact-details">
              <span>Email:</span>
              <span>Phone :</span>
            </div>
            <div className="left__menu-contact-details">
              <Link target="_blank" to="mailto:contact@ravisarajayamanna.com">
                contact@ravisarajayamanna.com
              </Link>
              <Link target="_blank" to="https://wa.me/779415754">
                +94 77 941 5754
              </Link>
            </div>
          </div>
          <p className="copyright">
            © {year} Ravisara Jayamanna, All Rights Reserved. Powered by{" "}
            <Link target="_blank" to="https://helabitz.com">
              Hela Bitz
            </Link>
          </p>
        </div>
        <img
          className="menu__icon-mobile"
          src={MenuIcon}
          alt="Menu"
          onClick={handleMenuClick}
        />
        <div
          className="moblie-nav"
          style={{
            transform: toggleMobileMenu ? "translateX(0%)" : "translateX(100%)",
            transition: "transform 0.3s ease-in-out", // Optional: Smooth transition effect
          }}
        >
          <img
            className="close__menu-mobile"
            src={closeIcon}
            alt="close menu"
            onClick={handleMenuClick}
          />
          <ul className="menu moblieMenu">
            {nav__links.map((item, index) => (
              <li
                className="nav__item"
                key={index}
                onMouseEnter={() => handleMouseEnter(index)}
              >
                <NavLink
                  to={item.path}
                  className={(navClass) =>
                    navClass.isActive ? "nav__active" : ""
                  }
                >
                  {item.display}
                </NavLink>
                {hoveredIndex === index && item.submenu && (
                  <ul className="submenu">
                    {item.submenu.map((subItem, subIndex) => (
                      <li className="submenu__item" key={subIndex}>
                        <NavLink to={subItem.path}>{subItem.display}</NavLink>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;
